import { Button } from '@core/ui';
import { hideShowTooEarly, useAppDispatch } from '@online-webinar/store';
import { useTranslation } from 'react-i18next';
import { Popup, Separator } from '../../atoms';
import { CountDownTimer, OnlineViewers } from '../../molecules';

export const TooEarlyPopup = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const closePopup = () => {
        dispatch(hideShowTooEarly());
    };

    return (
        <Popup
            title={t('Broadcaster.Dialog.TooEarly.Title')}
            isCloseFunctionality={true}
            hasWarning={true}
            open={true}
            onClose={() => closePopup()}
            onConfirm={() => {}}
        >
            <div>
                <p>{t('Broadcaster.Dialog.TooEarly.Text')}</p>
                <div className="border border-solid border-gray-200 rounded-lg p-4 text-center my-4">
                    <CountDownTimer />
                    <Separator />
                    <OnlineViewers />
                </div>
                <Button variant="primary" onClick={() => closePopup()} classNames="w-full">
                    {t('Generic.Button.Continue')}
                </Button>
            </div>
        </Popup>
    );
};
